import {PersonDocumentRetention, PersonDocumentRetentionRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {COLOR_DISMISSED} from "../../../../components/layout/colors";
import {TableCell, Typography} from "@mui/material";
import {useApiManager} from "../../../../components/utils/api";
import React from "react";
import {RETENTION_BASIS_LABELS} from "./labels";

/** Plazos de conservación de los documentos de persona (#13996), del registro de tratamientos. */
export const PersonDocumentRetentionListPage = () => {
	const apiManager = useApiManager();

	const listConfig: AppListConfig<PersonDocumentRetention> = {
		title: "Plazos de conservación",
		onClick: "/app/admin/compliance/retention",
		headers: [
			{title: "Nombre"},
			{title: "Tipo de documento"},
			{title: "Plazo"},
			{title: "Tratamiento", width: 110},
		],
		decorator: (bean: PersonDocumentRetention) => (
			<>
				<TableCell style={{color: bean.dismissed ? COLOR_DISMISSED : ""}}>
					<Typography variant="body2" fontWeight={600}>{bean.name}</Typography>
				</TableCell>
				<TableCell>
					{bean.type?.name
						? <Typography variant="body2">{bean.type.name}</Typography>
						: <Typography variant="body2" color="text.secondary">Todos</Typography>}
				</TableCell>
				<TableCell>
					<Typography variant="body2">{bean.months} meses · {RETENTION_BASIS_LABELS[bean.basis] || bean.basis}</Typography>
				</TableCell>
				<TableCell><Typography variant="body2" color="text.secondary">{bean.treatment || "—"}</Typography></TableCell>
			</>
		),
		supplier: async (currentPage, size, term, showDismissed) => {

			const ctrl = apiManager.factory(PersonDocumentRetentionRestControllerApiFactory);
			return ctrl.pagePersonDocumentRetention(currentPage, size, undefined, term, showDismissed);
		},
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};
